import { render, staticRenderFns } from "./StreamerWallet.vue?vue&type=template&id=09a7c17d&"
import script from "./StreamerWallet.vue?vue&type=script&lang=js&"
export * from "./StreamerWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports